<template>
    <div class="loading">
        <div class="loading__round"></div>
    </div>
</template>


<script>
  export default {
    name: 'Loading'
  }
</script>


<style>
</style>
